import { createContext, useContext } from "react";

// Lets the current page (via PageContainer) publish its title so the Navbar
// (top header bar) can display it, instead of the title sitting in the body.
export const PageTitleContext = createContext({
  title: "",
  setTitle: () => {},
});

export const usePageTitle = () => useContext(PageTitleContext);
